/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import { Virtuoso } from 'react-virtuoso';
import { SearchBox } from './SearchBox';
import Filters from './Filters';
import { Heading, SubHeading, Tagline } from './Type';
import Arrow from './Arrow';
import { ReactComponent as IconFilter } from '../assets/icons/filter.svg';
import { ReactComponent as IconClose } from '../assets/icons/close.svg';
import { ReactComponent as IconCloseCirc } from '../assets/icons/close-circ.svg';
import { ReactComponent as IconLeftArrow } from '../assets/icons/left-arrow.svg';
import { StyledSearchBoxInner } from './Styles';
import Button from './Button';
import LocationContext from './Context';
import StockistCard from './StockistCard';
import { useWindowSize } from '../hooks';
import ButtonToggle from './ButtonToggle';
import { truncateString } from '../utils/truncateString';

interface MapAsideProps {
    showData: boolean;
    stockists: any;
    listRef: React.MutableRefObject<any>;
    showSearch: boolean;
    loading: boolean;
    called: boolean;
    setShowSearch: any;
    showFilters: boolean;
    setShowFilters: any;
}

interface StyledMapAsideProps {
    showSearch: boolean;
}

const StyledStockistList = styled.div`
    padding: 12px 0 0 0;
    margin: 0 -16px;
    flex-grow: 1;
    position: relative;
    overflow: hidden;
    overflow-y: auto;
    .react-loading-skeleton + .react-loading-skeleton {
        margin-top: 12px;
    }
`;

const StyledMapAside = styled.aside<StyledMapAsideProps>`
    ${({ showSearch, theme }) => css`
        width: 100%;
        background-color: #fff;
        overflow: visible;
        transition: transform 0.6s ease;
        z-index: 97;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
        border: 0;
        display: flex;
        flex-direction: column;
        height: 248px;

        @media (min-width: ${theme.breakpoints.sm}px) {
            position: absolute;
            left: 0;
            bottom: 0;
            top: 0;
            height: auto;
            width: 435px;
        }

        ${!showSearch &&
        css`
            transition: transform 0.6s cubic-bezier(0.55, 0.05, 0.57, 1.21);
            transform: translateX(-95%);
        `}
    `}
`;

const StyledToggleButton = styled.button<StyledMapAsideProps>`
    ${({ theme, showSearch }) => css`
        position: absolute;
        left: 100%;
        top: 60px;
        z-index: 99;
        width: 48px;
        height: 48px;
        background-color: ${theme.colors.brand};
        color: #fff;
        cursor: pointer;
        border: 0;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        outline: 0;
        svg: {
            width: 26px;
            height: auto;

            transition: transform 0.6s cubic-bezier(0.55, 0.05, 0.57, 1.21);
        }
        ${!showSearch &&
        css`
            svg {
                transform: rotate(180deg);
            }
        `}
    `}
`;

const StyledFilterGroup = styled.div`
    display: flex;
    flex-flow: row wrap;
    padding: 0;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;

    > * {
        align-self: flex-start;
        /* margin-bottom: 10px; */
    }

    > * + * {
        /* margin-left: 10px; */
    }
`;

const StyledCardMessage = styled.div`
    padding: 16px;
    border: 2px solid #fff;
    background-color: #fff;
    border-radius: 3px;
    margin: 0 16px;
    font-size: 16px;
    line-height: 18px;
`;
const StyledCloseButton = styled.div`
    ${({ theme }) => css`
        position: absolute;
        right: 24px;
        top: 24px;

        .icon svg {
            width: 16px;
            height: 16px;
        }

        @media (min-width: ${theme.breakpoints.sm}px) {
            right: 48px;
        }
    `}
`;

interface StyledAsideFiltersProps {
    active?: boolean;
}
const StyledAsideFilters = styled(StyledSearchBoxInner)<StyledAsideFiltersProps>`
    ${({ theme, active }) => css`
        position: absolute;
        top: 98px;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        transition: transform 0.6s cubic-bezier(0.55, 0.05, 0.57, 1.21);
        transform: translateY(100%);

        ${active &&
        css`
            transform: translateY(0);
        `}

        @media (min-width: ${theme.breakpoints.sm}px) {
            top: 0;
        }
    `}
`;

interface StyledResultsProps {
    viewType: string;
}
const StyledResults = styled(StyledSearchBoxInner)<StyledResultsProps>`
    ${({ theme, viewType }) => css`
        transition: height 0.2 ease-in;

        @media (max-width: ${theme.breakpoints.sm - 1}px) {
            position: absolute;
            right: 0;
            left: 0;
            bottom: 0;
            height: 248px;
            z-index: 98;

            ${viewType === 'LIST' &&
            css`
                height: auto;
                top: 0;
            `}
        }
    `}
`;
const StyledSearch = styled(StyledSearchBoxInner)`
    ${({ theme }) => css`
        @media (max-width: ${theme.breakpoints.sm - 1}px) {
            position: absolute;
            right: 0;
            left: 0;
            top: 0;
        }

        @media (min-width: ${theme.breakpoints.sm}px) {
            padding: 24px 48px;
        }
    `}
`;
const StyledBack = styled(Link)`
    margin-bottom: 20px;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    svg {
        color: #ffffff;

        text-decoration: none;
    }

    span {
        color: #ffffff;
        text-decoration: underline;
    }

    svg {
        width: 8px;
        height: auto;
        margin-right: 4px;
    }
`;

// const MyScrollContainer: FC<any> = ({ className, style, reportScrollTop, scrollTo, children }) => {
//     const elRef = useRef<HTMLDivElement>(null);

//     scrollTo((scrollTop) => {
//         if (!!elRef && elRef.current) {
//             elRef.current.scrollTo({ top: scrollTop });
//         }
//     });

//     return (
//         <div
//             ref={elRef}
//             onScroll={(e: any) => reportScrollTop(e.target.scrollTop)}
//             style={{
//                 ...style,
//             }}
//             tabIndex={0}
//             className={className}
//         >
//             {children}
//         </div>
//     );
// };

const MapAside: FC<MapAsideProps> = ({
    showData,
    stockists,
    listRef,
    showSearch,
    setShowSearch,
    showFilters,
    setShowFilters,
    loading,
    called,
}) => {
    const { filters, setFilters, selectedMarker } = useContext(LocationContext);

    const [visibleRange, setVisibleRange] = useState<any[]>(['-', '-']);
    const [viewType, setViewType] = useState<string>('MAP');
    const [listHeight, setListHeight] = useState<number>();
    const [lastHeight, setLastHeight] = useState<number>();

    const { width, height: windowHeight } = useWindowSize();

    const itemWrap = useRef<HTMLDivElement>();

    useEffect(() => {
        if (
            (!called && itemWrap.current?.offsetHeight && !listHeight) ||
            (itemWrap.current?.offsetHeight && windowHeight !== lastHeight)
        ) {
            const newHeight = Math.floor(itemWrap.current.offsetHeight) - 20;
            setListHeight(newHeight);
            setLastHeight(windowHeight);
        }
    }, [itemWrap.current, called, listHeight, windowHeight, lastHeight]);

    const handleShowSearch = () => setShowSearch((s) => !s);

    const handleToggleFilters = () => setShowFilters((s) => !s);

    const handleRemoveFilter = (filter) => {
        setFilters((state) => {
            // 1. Copy the state
            const newState = { ...state };
            // 2. Remove required
            delete newState[filter];
            // 3. return it
            return newState;
        });
    };

    const GenerateItem = (index) => {
        const { node, distance } = stockists[index];
        return (
            <StockistCard
                stockist={node}
                selectedMarker={selectedMarker}
                count={index + 1}
                distance={distance}
                key={index}
            />
        );
    };

    const viewOptions = [
        {
            label: 'Map',
            value: 'MAP',
        },
        {
            label: 'List',
            value: 'LIST',
        },
    ];

    const skeletonCount = listHeight ? Math.floor(listHeight / 164) : 3;

    const noResults = !loading && called && stockists.length === 0;

    return (
        <StyledMapAside showSearch={showSearch}>
            <StyledToggleButton type="button" onClick={handleShowSearch} showSearch={showSearch}>
                <Arrow />
            </StyledToggleButton>
            <StyledSearch brand isMap>
                {width && width >= 768 && (
                    <>
                        <StyledBack to="/">
                            <IconLeftArrow /> <span>Back</span>
                        </StyledBack>

                        <Heading>Find a stockist</Heading>

                        <Tagline>Search for town, city or postcode</Tagline>
                    </>
                )}

                <SearchBox isMapPage />
            </StyledSearch>

            <StyledAsideFilters muted isMap active={showFilters}>
                <StyledCloseButton>
                    <Button
                        color="link"
                        label="Close"
                        size="small"
                        onClick={handleToggleFilters}
                        icon={<IconCloseCirc />}
                    />
                </StyledCloseButton>
                <SubHeading>Filter Results</SubHeading>
                <Filters isMapPage setShowFilters={setShowFilters} noResults={noResults} />
            </StyledAsideFilters>

            <StyledResults muted stretch isMap viewType={viewType}>
                <StyledFilterGroup>
                    <Button
                        color="muted"
                        label="Filter Results"
                        size="small"
                        onClick={handleToggleFilters}
                        icon={<IconFilter />}
                        iconBefore
                    />
                    {width && width < 768 && (
                        <ButtonToggle active={viewType} action={setViewType} options={viewOptions} subAction={setLastHeight} />
                    )}

                    {filters?.brand && width && width >= 768 && (
                        <Button
                            color="grey"
                            label={truncateString(filters.brand.label)}
                            size="small"
                            onClick={() => handleRemoveFilter('brand')}
                            icon={<IconClose />}
                        />
                    )}
                    {filters?.product && width && width >= 768 && (
                        <Button
                            color="grey"
                            label={truncateString(filters.product.label)}
                            size="small"
                            onClick={() => handleRemoveFilter('product')}
                            icon={<IconClose />}
                        />
                    )}
                </StyledFilterGroup>

                <StyledStockistList ref={itemWrap as any}>
                    {!called || (loading && <Skeleton count={skeletonCount} height="144px" />)}
                    {noResults && (
                        <StyledCardMessage>
                            <b>Sorry no results found,</b> please try searching again.
                        </StyledCardMessage>
                    )}
                    {showData && (
                        <Virtuoso
                            ref={listRef}
                            totalCount={stockists.length}
                            item={GenerateItem}
                            style={{
                                height: listHeight ? `${listHeight}px` : '565px',
                                width: '100%',
                            }}
                            overscan={200}
                            scrollSeek={{
                                enter: (velocity) => Math.abs(velocity) > 200,
                                exit: (velocity) => {
                                    const shouldExit = Math.abs(velocity) < 30;
                                    if (shouldExit) {
                                        setVisibleRange(['-', '-']);
                                    }
                                    return shouldExit;
                                },
                                change: (_velocity, { startIndex, endIndex }) =>
                                    setVisibleRange([startIndex, endIndex]),
                                // You can use index to randomize
                                // and make the placeholder list more organic.
                                placeholder: () => <Skeleton count={1} height="144px" />,
                            }}
                        />
                    )}
                </StyledStockistList>
            </StyledResults>
        </StyledMapAside>
    );
};

export default MapAside;
